import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

class LastSeenUpdate extends Component {
  componentDidMount() {
    const { userId } = this.props;
    if (
      process.env.REACT_APP_ACTIVITY_LOG_URL &&
      process.env.REACT_APP_ACTIVITY_LOG_KEY &&
      userId
    ) {
      const url = `${process.env.REACT_APP_ACTIVITY_LOG_URL}/v1/users/${userId}`;
      const request = axios({
        method: 'POST',
        url,
        headers: { Authorization: process.env.REACT_APP_ACTIVITY_LOG_KEY }
      });
      request.then(() => {});
    }
  }

  render() {
    return <></>;
  }
}

const mapStateToProps = state => {
  return {
    userId: state.user && state.user.profile && state.user.profile.id
  };
};

export default connect(mapStateToProps)(LastSeenUpdate);
